// One wrap-up per callback (Storm 16 Oct 11:46 "go one wrap-up").
// A callback is two Connect contacts: the TASK (the booked callback) and the VOICE leg the agent
// dials from it. The agent used to wrap up both (16 Oct test: 851d75ce at 11:37:19, then task
// 10b507bc at 11:37:45). Now saving the call's wrap-up also ends the task and completes its
// wrap-up with the same outcome. Pure helpers, so scripts/verify-one-wrapup.mjs can prove them.

// Same allowlist as the server's RECOVERY_DIAL_CLOSING_DISPOSITIONS (knktr-agent-wrapup/callback.mjs):
// the call's wrap-up closes the callback record for these, so the task closes with it. "Test" closes
// neither (Storm 2026-09-24): the agent ends a test task by hand, as before.
export const TASK_CLOSING_DISPOSITIONS = new Set(['Resolved', 'Follow-up required', 'Callback scheduled', 'Requires client action']);
export const closesTask = disposition => TASK_CLOSING_DISPOSITIONS.has(disposition);

// Storm 2026-10-22 ("go test closes task code"): Test now ALSO ends the callback TASK, so a test
// callback needs one wrap-up, not two. The callback RECORD still stays open on Test (the server
// allowlist above is unchanged), which is what the 24 Sep rule protects.
export const endsCallbackTask = disposition => closesTask(disposition) || disposition === 'Test';

const attr = (c, k) => { try { return c?.getAttributes?.()?.[k]?.value ?? null; } catch { return null; } };
const typeOf = c => { try { return String(c?.getType?.() || '').toLowerCase(); } catch { return ''; } };
const statusOf = c => { try { return c?.getStatus?.()?.type ?? null; } catch { return null; } };
const idOf = c => { try { return c?.getContactId?.() ?? null; } catch { return null; } };

// The connected callback TASK this call was dialled for: same callbackId, still connected.
// Only ever a task, never the voice leg itself, never a task for another callback.
export function findCallbackTask(contacts, callbackId, voiceContactId = null) {
  if (!callbackId || !Array.isArray(contacts)) return null;
  return contacts.find(c => typeOf(c) === 'task' && statusOf(c) === 'connected'
    && attr(c, 'callbackId') === callbackId && idOf(c) !== voiceContactId) || null;
}

// The task's wrap-up row. Same outcome and notes as the call, marked as closed with it.
// Never repeats the call's side effects: no client alert, no callback booking, no callbackId
// (the call's own wrap-up already closed the callback record).
export function taskWrapPayload({ taskCtx, voiceContactId, disposition, notes, agentUsername }) {
  const lead = `Closed together with the callback call ${voiceContactId || '(unknown)'}.`;
  return {
    tenantId: taskCtx.tenantId,
    contactId: taskCtx.contactId,
    initialContactId: taskCtx.initialContactId ?? null,
    brandName: taskCtx.brandName ?? null,
    aiSummary: taskCtx.aiSummary ?? null,
    notes: notes ? `${lead} ${notes}` : lead,
    disposition,
    clientActionRequired: false,
    agentUsername: agentUsername || 'unknown',
  };
}
